import { Component, Output, EventEmitter, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoryService } from '../story.service';
import { LayoutService } from '../../layout.service';

import { Color } from '../../shared/interfaces/color';

@Component({
  selector: 'app-color-palette',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './color-palette.component.html',
  styleUrl: './color-palette.component.scss'
})
export class ColorPaletteComponent implements OnInit {
  @Output() colorInfo = new EventEmitter<{ colorHex: string; colorType: string; colorIndex: number; }>()
  @Input() colors: Color[] = []
  @Input() textParagraphCreated!: boolean
  
  isDesktop = this.layoutService.isDesktop

  constructor(
    private storyService: StoryService,
    private layoutService: LayoutService
  ){}

  ngOnInit(){
    this.storyService.textParagraphCreated.subscribe(res => this.textParagraphCreated = res)
  }

  setTextColor(hexCode: string, colorType: string, colorIndex: number){
    this.colorInfo.emit({ colorHex: hexCode, colorType: colorType, colorIndex: colorIndex })
  }
}
